module.exports = __webpack_public_path__ + "static/q1-baecf5d337678955c1ed35cd87b74446.svg";